// Shared chart theme for the EV Performance & Range Simulator's Recharts panels — the
// first charts in this codebase, so these constants establish the house style rather
// than following an existing one. Categorical colors are the dataviz skill's validated
// default 8-hue palette (run through scripts/validate_palette.js against this site's
// white technical-card surface — all 8 pass the CVD/lightness/contrast gates); AUTOXIUM's
// brand blue is reserved for chrome (titles, icons) rather than data marks, since it
// fails the mark lightness-band check on a white surface.

export const SERIES_COLORS = [
  '#2a78d6', // 1 blue
  '#eb6834', // 2 orange
  '#1baf7a', // 3 aqua
  '#eda100', // 4 yellow
  '#e87ba4', // 5 magenta
  '#008300', // 6 green
  '#4a3aa7', // 7 violet
  '#e34948', // 8 red
];

export const CHART_GRID = '#E2E8F0';   // structure token (hairline gridlines)
export const CHART_AXIS = '#94A3B8';   // muted axis line/ticks
export const CHART_TEXT = '#64748B';   // muted-foreground, axis tick labels

export const AXIS_TICK_STYLE = { fontSize: 11, fill: CHART_TEXT, fontFamily: 'JetBrains Mono, monospace' };
export const AXIS_LABEL_STYLE = { fontSize: 11, fill: CHART_TEXT, fontFamily: 'JetBrains Mono, monospace' };

export const LINE_PROPS = { strokeWidth: 2, dot: false, activeDot: { r: 4, strokeWidth: 2, stroke: '#fff' } };

export const TOOLTIP_CONTENT_STYLE = {
  fontSize: 12,
  fontFamily: 'JetBrains Mono, monospace',
  border: '1px solid #E2E8F0',
  borderRadius: 6,
  boxShadow: '0 2px 8px rgba(15, 23, 42, 0.08)',
};

export const TOOLTIP_LABEL_STYLE = { color: '#0A0F1C', fontWeight: 600, marginBottom: 4 };

export const LEGEND_STYLE = { fontSize: 12, fontFamily: 'JetBrains Mono, monospace', paddingTop: 8 };
